<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xvii"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td class="tdleft"><i>CO</i></td>
<td class="tdleft">John Calvin, <i>Ioannis Calvini opera omnia quae supersunt</i></td>
</tr>
<tr>
<td class="tdleft"><i>Comm</i></td>
<td class="tdleft"><i>Communio</i></td>
</tr>
<tr>
<td class="tdleft"><i>Inst.</i></td>
<td class="tdleft">John Calvin, <i>Institutes of the Christian Religion</i></td>
</tr>
<tr>
<td class="tdleft"><i>TS</i></td>
<td class="tdleft"><i>Theological Studies</i></td>
</tr>
<tr>
<td class="tdleft"><i>VF</i></td>
<td class="tdleft"><i>Verkündigung und Forschung</i></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?2f35b386